import './NavigationBar.css'
import { signOut } from 'firebase/auth'
import { auth } from '../../config'
import { useContext } from 'react'
import { AuthContext } from '../../context/AuthContext'

const NavigationBar = () => {
  const { curUser } = useContext(AuthContext)

  return (
    <div>
      <nav>
        <a href="/">Khris ChatRoom</a>

        <div className="account">
          <p>
            Welcome, <span>{curUser.displayName}</span>
          </p>
          <div className="user" tabIndex={'0'}>
            <i className="icon-user"></i>
          </div>

          <div className="menu">
            <button
              className="logout"
              onClick={() => {
                signOut(auth)
              }}
            >
              Log out
            </button>
          </div>
        </div>
      </nav>
    </div>
  )
}

export default NavigationBar
